<div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search" class="searchbox-wrapper">
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <input
      #searchInput
      [ngClass]="{'searchbox-is-not-active': isSearchboxNotActive$ | async}"
      [placeholder]="'searchBox.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      aria-autocomplete="both"
      [attr.aria-label]="'searchBox.placeholder' | cxTranslate"
      (focus)="open()"
      (click)="open()"
      (input)="search(searchInput.value);saveQuery(searchInput.value)"
      (blur)="close($any($event))"
      (keydown.escape)="close($any($event))"
      (keydown.enter)="
        close( true);
        launchSearchResult(searchInput.value);
        updateChosenWord(searchInput.value)
      "
      (keydown.arrowup)="focusPreviousChild($any($event))"
      (keydown.arrowdown)="focusNextChild($any($event))"
      value="{{ chosenWord }}"
      />

      <div role="presentation" class="search-icon" [ngClass]="getSearchIconClass(searchInput.value)" (click)=" onCustomSubmit($event);">
        <cx-icon type="SEARCH2" [ngClass]="getSearchIconClass(searchInput.value)"></cx-icon>
      </div>

      <button
        [attr.aria-label]="'common.search' | cxTranslate"
        class="search"
        (click)="clear(searchInput); onCommonSubmit($event)"
        >
        <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
      </button>
    </label>
  </div>

  @if (results$ | async; as result) {
    <div
      class="results"
      id="results"
      (click)="close($any($event), true)"
      role="dialog"
      >
      @if (result.message) {
        <div
          class="message"
          [innerHTML]="result.message"
        ></div>
      }
      <ul
        class="suggestions"
        attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}"
        role="listbox"
        >
        @for (suggestion of result.suggestions; track suggestion) {
          <li>
            <a
              role="option"
              [innerHTML]="suggestion | cxHighlight: searchInput.value"
        [routerLink]="
          {
            cxRoute: 'search',
            params: { query: suggestion }
          } | cxUrl
        "
              (keydown.arrowup)="focusPreviousChild($any($event))"
              (keydown.arrowdown)="focusNextChild($any($event))"
              (keydown.enter)="close($any($event), true)"
              (keydown.escape)="close($any($event), true)"
              (blur)="close($event)"
              (mousedown)="preventDefault($event)"
        (click)="
          dispatchSuggestionEvent({
            freeText: searchInput.value,
            selectedSuggestion: suggestion,
            searchSuggestions: result.suggestions ?? []
          });
          updateChosenWord(suggestion)
        "
              >
            </a>
          </li>
        }
      </ul>
      @if (result.products) {
        <ul
          class="products"
          attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}"
          role="listbox"
          >
          @for (product of result.products; track product) {
            <li>
              <a
                role="option"
        [routerLink]="
          {
            cxRoute: 'product',
            params: product
          } | cxUrl
        "
                [queryParams]="{ source: pdpCallSource }"
                [class.has-media]="config.displayProductImages"
                (keydown.arrowup)="focusPreviousChild($any($event))"
                (keydown.arrowdown)="focusNextChild($any($event))"
                (keydown.enter)="close($any($event), true)"
                (keydown.escape)="close($any($event), true)"
                (blur)="close($any($event))"
                (mousedown)="preventDefault($event)"
        (click)="
          dispatchProductEvent({
            freeText: searchInput.value,
            productCode: product.code
          })
        "
                >
                @if (config.displayProductImages) {
                  <cx-media
                    [container]="product.images?.PRIMARY"
                    format="thumbnail"
                    role="presentation"
                  ></cx-media>
                }
                <div class="name" [innerHTML]="product.nameHtml"></div>
                <div class="article-number" [innerHTML]="product.manufacturerAID"></div>
                <div class="price">{{ product.price?.formattedValue }}</div>
              </a>
            </li>
          }
        </ul>
      }
      <span id="initialDescription" class="cx-visually-hidden">
        {{ 'searchBox.initialDescription' | cxTranslate }}
      </span>
      @if (result.suggestions?.length || result.products?.length) {
        <div
          aria-live="assertive"
          class="cx-visually-hidden"
          >
          {{
          'searchBox.suggestionsResult'
          | cxTranslate: { count: result.suggestions?.length }
          }}
          {{
          'searchBox.productsResult'
          | cxTranslate: { count: result.products?.length }
          }}
          {{ 'searchBox.initialDescription' | cxTranslate }}
        </div>
      }
    </div>
  }
